import type { LogoProps } from '../../logo.types'
import { logos } from './logos'

type LogoRDSaudeProps = LogoProps

export const LogoRDSaude = (props: LogoRDSaudeProps) => {
  const { size, type } = props

  const SvgComponent = logos[type][size]

  return SvgComponent
}
